import { Button, Stack } from '@mui/material'
import SeriesDefinitionFormList from '../series/SeriesDefinitionFormList'
import { Control } from 'react-hook-form'
import { QcStudyDefinitionCreateFormValues } from '../../schemas/StudyAndSeriesDefinitionValidationSchema'
import { QcTimepointContainerSubmission } from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import StudyDefinitionForm from './StudyDefinitionForm'

export default function StudyAndSeriesDefinitionForm({
  control,
  qcTimepointContainerSubmissions,
  saveDisabled,
}: {
  control: Control<QcStudyDefinitionCreateFormValues>
  qcTimepointContainerSubmissions: QcTimepointContainerSubmission[]
  saveDisabled: boolean
}) {
  return (
    <Stack spacing={SPACING.spacingLg}>
      <StudyDefinitionForm control={control} qcTimepointContainerSubmissions={qcTimepointContainerSubmissions} />
      <SeriesDefinitionFormList control={control} qcTimepointContainerSubmissions={qcTimepointContainerSubmissions} />
      <Stack direction="row" alignItems="center" justifyContent="end">
        <Button
          variant="contained"
          sx={{
            color: 'text.primary',
            py: SPACING.spacingSm,
            px: SPACING.seriesDefinitionsFormSpacing,
          }}
          color="secondary"
          type="submit"
          disabled={saveDisabled}
        >
          Save changes
        </Button>
      </Stack>
    </Stack>
  )
}
